import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  FetchPhysicalDockInventoryActions as Actions,
  FetchPhysicalDockInventoryRequestAction as RequestAction,
} from 'store/ducks/physicalDocks';

export function* fetchPhysicalDockInventoryRequest(action: any) {
  const { warehouseId, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.get, 'docks-physical/inventory', {
      params: { warehouseId },
    });
    const shouldCommit = onSuccess?.();
    if (shouldCommit === false) return;
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    const shouldCommit = onFailure?.();
    if (shouldCommit === false) return;
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
